import { Menu, Typography } from '@mui/material';
import FlexContainer from 'components/FlexContainer';
import { CustomerAvatar } from 'features/customer/CustomerAvatar';
import {
  getIsApiCustomer,
  getUserEmail,
  getUserImage,
  getUserName
} from 'features/customer/store/selectors';
import { DarkModeToggleItem } from 'features/pageSidebar/sidebarItems/actions/account/DarkModeToggleItem';
import ProfileItem from 'features/pageSidebar/sidebarItems/actions/account/ProfileItem';
import SignOutItem from 'features/pageSidebar/sidebarItems/actions/account/SignOutItem';
import { WorkspaceItem } from 'features/pageSidebar/sidebarItems/actions/account/WorkspaceItem';
import { LanguageButton } from 'features/pageSidebar/sidebarItems/actions/LanguageButton';
import { SidebarItem } from 'features/pageSidebar/sidebarItems/SidebarItem';
import React, { MouseEvent } from 'react';
import gtmIds from 'services/tracking/GTMIds';
import { useAppSelector } from 'store/hooks';
import styled from 'styled-components';
import useDropdown from 'utils/hooks/useDropdown';
import { withTestId } from 'utils/utils';

export const SidebarItemAccount = () => {
  const { anchorElement, isOpen, open, close } = useDropdown();
  const isApiCustomer = useAppSelector(getIsApiCustomer);
  const userName = useAppSelector(getUserName);
  const userEmail = useAppSelector(getUserEmail);
  const userImage = useAppSelector(getUserImage);

  const handleClose = () => {
    close();
  };

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    open(event);
  };

  return (
    <>
      <SidebarItem
        gtmId={gtmIds.sidebar.accountMenu}
        icon={<CustomerAvatar name={userName} image={userImage ?? undefined} size="24px" />}
        onClick={handleOpen}
        tooltip="layout.sidebar.actions.profile.menu_trigger"
        testAttribute="sidebar-account-menu-trigger"
      >
        <LabelContainer>
          <Typography variant="body1" noWrap={true}>
            {userName}
          </Typography>
          <Typography variant="body2" color="text.secondary" noWrap={true}>
            {userEmail}
          </Typography>
        </LabelContainer>
      </SidebarItem>

      <StyledMenu
        {...withTestId('account-menu-dropdown')}
        open={isOpen}
        anchorEl={anchorElement}
        onClose={close}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        {!isApiCustomer && <ProfileItem onClose={handleClose} />}

        {!isApiCustomer && <WorkspaceItem onClose={handleClose} />}

        <LanguageButton onClose={handleClose} />

        <DarkModeToggleItem />

        <SignOutItem onClose={handleClose} />
      </StyledMenu>
    </>
  );
};

const LabelContainer = styled(FlexContainer)`
  justify-content: space-between;
`;

const StyledMenu = styled(Menu)`
  .MuiList-root {
    width: 330px;
  }
`;
